<template>
  <div>
    <div v-if="fast.orderSn" class="detail_c">
      <div class="detail_top_total">
        <div class="avatar">
          <img :src="fast.userAvatarUrl" alt="" class="avatar_img" />
        </div>
        <div class="total_info">
          <div>
            <span class="userName">{{ fast.userName }}</span>
          </div>
          <div class="totalPrice">
            <span class="skuNum">下单商品共{{ fast.totalNum }}件</span>
          </div>
        </div>
        <div class="cundown_time">
          <van-count-down :time="fast.remainingTime">
            <template #default="timeData">
              <span class="item"
                ><span v-if="timeData.minutes < 10">0</span
                >{{ timeData.minutes }}</span
              >:<span class="item"
                ><span v-if="timeData.seconds < 10">0</span
                >{{ timeData.seconds }}</span
              >自动关闭
            </template>
          </van-count-down>
        </div>
      </div>
      <div v-if="fast.address" class="address">
        <div class="address_info">
          {{ fast.address.name }} {{ fast.address.phone }}
        </div>
        <div style="margin-top: 4px" class="address_detail">
          {{ fast.address.province }} {{ fast.address.city }}
          {{ fast.address.district }}
          {{ fast.address.addressLine }}
        </div>
      </div>
      <!-- 商品列表 -->
      <div class="detail_products">
        <div v-for="(item, index) in fast.detailList" :key="index">
          <div class="product_item">
            <img :src="item.skuPic" alt class="product_img" />
            <img
              v-if="item.isGift"
              src="@/assets/pay/gift.jpg"
              alt=""
              class="badge"
            />
            <div class="product_item_rt">
              <div class="name">{{ item.skuName }}</div>
              <div class="name_tags">
                <div class="tags_num">{{ item.skuSpec }}</div>
              </div>
              <div v-if="getExpirationAndGuarantee(item)" class="expiration">
                {{ getExpirationAndGuarantee(item) }}
              </div>
              <div class="price">
                <span class="p_price" v-html="$currency(item.finalPrice)" />
                <span class="p_sub">{{ `x${item.skuAmount}` }}</span>
              </div>
            </div>
          </div>
          <div
            v-if="
              fast.isFreshMilkCard &&
                fast.paid &&
                !fast.expenseCardOverdue &&
                fast.expenseCardStatus === 2
            "
            class="send_card"
            @click="goCard(item.slug)"
          >
            <img src="@/assets/mine/wechat.png" alt="" class="wx_img" />
            赠此卡给好友
          </div>
        </div>
      </div>
      <!-- 订单编号 -->
      <div class="detail_info">
        <van-cell title="联系电话">
          <div class="cell_value">{{ fast.contactPhone }}</div>
        </van-cell>
        <van-cell title="买家留言">
          <div class="cell_value">{{ fast.userMessage }}</div>
        </van-cell>
        <van-cell v-if="$appSource === 3" title="配送方式">
          <div class="cell_value">{{ deliveryModeTitle }}</div>
        </van-cell>
        <van-cell v-if="$appSource === 3 && fast.valueAddedServiceNames" title="贴心服务">
          <div class="cell_value">{{ fast.valueAddedServiceNames }}</div>
        </van-cell>
      </div>
      <!-- 商品金额 -->
      <div class="detail_prices">
        <van-cell title="商品总金额">
          <div>
            <span class="cell_value" v-html="$currency(fast.orderMoney)" />
          </div>
        </van-cell>
        <van-cell title="税率费用">
          <div>
            <span class="cell_value" v-html="$currency(fast.taxMoney)" />
          </div>
        </van-cell>
        <!-- <van-cell v-if="$appSource === 3 && fast.valueAddedServiceAmount && fast.valueAddedServiceAmount > 0" title="贴心服务">
          <div>
            <span class="cell_value" v-html="$currency(fast.valueAddedServiceAmount)" />
          </div>
        </van-cell> -->
        <van-cell title="运费">
          <div>
            <span class="cell_value" v-if="fast.freightMoney > 0">
              <span v-html="$currency(fast.freightMoney)" />
            </span>
            <span class="cell_value" v-else>免运费</span>
          </div>
        </van-cell>
      </div>
      <div style="text-align: center; font-size: 12px; padding: 10px">
        确认支付即表示同意
        <span style="color: #fd2824">《用户购买协议》</span>
      </div>
    </div>
    <div v-if="!fast.orderSn" class="error_c">
      <div>该订单不存在或已确认！</div>
    </div>
    <van-submit-bar
      :price="fast.total * 100 || 0"
      :button-text="buttonText"
      :button-type="buttonType"
      :disabled="fast.status !== 10"
      @submit="surePay"
    />
    <id-num-action-sheet
      v-if="showIdSheet"
      @closeSheet="closeSheet"
      @sure="sureRealName"
      @inputName="inputName"
      @inputId="inputId"
    />
  </div>
</template>

<script>
import { v1 as uuidv1 } from "uuid";
import md5 from "js-md5";
const wx = require("jweixin-module");

import IdNumActionSheet from "./components/IdNumActionSheet";

export default {
  components: {
    IdNumActionSheet,
  },
  data() {
    return {
      canPay: true,
      time: 30 * 60 * 60 * 1000,
      showIdSheet: false,
      idCard: "",
      idName: "",
    };
  },
  computed: {
    fast() {
      const fast = this.$store.state.order.fast;
      return fast;
    },
    buttonText() {
      const fast = this.fast;
      if (fast.status === 10) {
        return "支付订单";
      } else if (fast.status > 10) {
        return "已支付";
      } else if (fast.status === -10 || fast.status === -11) {
        return "订单已关闭";
      } else if (fast.status == 5) {
        return "待审核";
      }
      return "";
    },
    buttonType() {
      const fast = this.fast;
      if (fast.status === 10) {
        return "danger";
      } else if (fast.status > 10) {
        return "success";
      } else if (fast.status === -10 || fast.status === -11) {
        return "warning";
      } else if (fast.status == 5) {
        return "warning";
      }
      return "default";
    },
    deliveryModeTitle() {
      const modeMap = {
        0: "自提",
        1: "本地配送",
        2: "直邮",
      };
      return modeMap[this.fast.deliveryMode] || "直邮";
    },
  },
  mounted() {
    console.log(this);
    const query = this.$route.query;
    if (query.code && query.code !== localStorage.WECHAT_PAY_CODE) {
      this.getData();
      localStorage.WECHAT_PAY_CODE = query.code;
      const url = "order/wechatPayFastOrderDis";
      this.$store
        .dispatch(url, {
          params: {
            orderSn: query.orderSn,
            code: query.code,
            kind: 5,
          },
        })
        .then((response) => {
          console.log(response);
          const self = this;
          const urlJsticket = "order/loadJsticketFastOrderDis";
          this.$store
            .dispatch(urlJsticket, {
              params: {
                url: encodeURIComponent(window.location.href),
              },
            })
            .then((res1) => {
              this.$toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: "加载中",
                loadingType: "spinner",
                className: "loading_toast",
              });
              wx.config({
                debug: false,
                appId: res1.appId,
                timestamp: res1.timestamp,
                nonceStr: res1.nonceStr,
                signature: res1.signature,
                jsApiList: ["chooseWXPay"],
              });
              wx.ready(() => {
                self.$toast.clear();
                wx.chooseWXPay({
                  timestamp: response.timeStamp,
                  nonceStr: response.nonceStr,
                  package: response.package,
                  signType: response.signType,
                  paySign: response.paySign,
                  success: function() {
                    const secretKey = "a02ade6080c33cf74a39fe1a387f956a";
                    const random = uuidv1();
                    const md5Str =
                      secretKey +
                      "orderSn" +
                      query.orderSn +
                      "random" +
                      random +
                      secretKey;
                    const sign = md5(md5Str);
                    const data = {
                      orderSn: query.orderSn,
                      random,
                      sign,
                    };
                    const urlSuccNote = "order/paySuccessNoticeBackgroundDis";
                    self.$store
                      .dispatch(urlSuccNote, {
                        params: data,
                      })
                      .then(() => {
                        self.getData();
                      })
                      .catch(() => {
                        self.getData();
                      });
                  },
                  fail: function() {
                    self.$toast("支付失败");
                    const host = window.location.host;
                    window.location.replace(
                      `https://${host}${self.$route.path}?orderSn=${query.orderSn}`,
                    );
                  },
                  cancel: function() {
                    self.$toast("支付失败");
                    const host = window.location.host;
                    window.location.replace(
                      `https://${host}${self.$route.path}?orderSn=${query.orderSn}`,
                    );
                  },
                });
              });
              wx.error((res) => {
                self.$toast.fail(res);
              });
            })
            .catch(() => {});
        })
        .catch(() => {
          const host = window.location.host;
          window.location.replace(
            `https://${host}${this.$route.path}?orderSn=${query.orderSn}`,
          );
        });
    } else {
      this.getData();
    }
  },
  methods: {
    getExpirationAndGuarantee(sku) {
      var temp = "";
      if (sku.isExpiration === 1 && sku.expiration) {
        temp = `有效期至: ${sku.expiration}`;
      }
      if (sku.isGuarantee === 1 && sku.guarantee) {
        temp = `有效期至: ${sku.guarantee}`;
      }
      return temp;
    },
    getData() {
      const { query } = this.$route;
      this.$store
        .dispatch("order/loadFastOrderDetail", {
          params: {
            orderSn: query.orderSn,
          },
        })
        .then(() => {})
        .catch(() => {});
    },
    backClick() {
      if (!this.fast.canPay) {
        return;
      }
      this.$dialog
        .confirm({
          title: "确认放弃支付吗？",
          message: "超过订单支付时效后，订单将被取消，请尽快完成支付",
          confirmButtonText: "继续支付",
          cancelButtonText: "放弃",
          confirmButtonColor: "#c19662",
        })
        .then(() => {})
        .catch(() => {
          this.$router.push({
            path: "/user/order/detail",
            query: {
              orderSn: this.$route.query.orderSn,
              store: this.$route.query.store,
            },
          });
        });
    },
    wechatLogin() {
      const host = window.location.host;
      const guid = uuidv1();
      const { query } = this.$route;
      const redirect_uri = encodeURIComponent(
        `https://${host}/user/order/fast/qqgpay?orderSn=${query.orderSn}`,
      );
      const appid = "wx0aa751f873923a04"; //妙客云appid
      var codeHost = window.location.host;
      if (
        codeHost !== this.$G("wap.myaz.com") &&
        codeHost !== this.$G("wap.myazstore.com")
      ) {
        codeHost = this.$G("wap.myaz.com");
      }
      const url = `https://${codeHost}/wechatauth.html?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=${guid}`;
      window.location.replace(url);
    },
    goToPay() {
      if (this.$appSource === 3) {
        this.$router.push({
          path: "/order/orderpay",
          query: {
            orderSn: this.fast.orderSn,
            fromValet: 1,
          },
        });
      } else {
        this.getWechatCode();
      }
    },
    surePay() {
      if (this.fast.requiredRealName) {
        this.showIdSheet = true;
        return;
      }
      this.goToPay();
    },
    getWechatCode() {
      if (this.isWechatBrowser()) {
        this.wechatLogin();
      } else {
        this.$toast("请在微信中访问页面进行支付");
      }
    },
    closeSheet() {
      this.showIdSheet = false;
    },
    inputName(name) {
      this.idName = name;
    },
    inputId(idNum) {
      this.idCard = idNum;
    },
    // 更新订单实名信息
    sureRealName() {
      if (this.fast.requiredRealName) {
        if (!this.idName) {
          this.$toast("请输入实名姓名");
          return;
        }
        if (!this.idCard) {
          this.$toast("请输入实名身份证号");
          return;
        }
        const params = {
          idcardName: this.idName,
          idcardNo: this.idCard,
          orderSn: this.fast.orderSn,
        };
        this.$store
          .dispatch("order/updateRealNameQQG", { params })
          .then(() => {
            this.closeSheet();
            this.goToPay();
          })
          .catch((msg) => {
            console.log(msg);
            this.closeSheet();
            this.$toast(msg);
          });
      }
    },
    isWechatBrowser: function() {
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") !== -1;
      return isWeixin;
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .van-submit-bar {
  z-index: 999 !important;
}
::v-deep .van-submit-bar__text {
  text-align: left;
}
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: "";
  clear: both;
  height: 0;
}
.left {
  float: left;
}
.right {
  float: right;
}
.error_c {
  padding: 120px 12px;
  text-align: center;
  font-size: 16px;
}
.detail_c {
  margin: 12px;
  text-align: left;
  padding-bottom: 60px;
}

.detail_products {
  margin-top: 10px;
  background: #fff;
  border-radius: 10px;
}

.product_item {
  display: flex;
  flex-direction: row;
  padding: 12px;
  position: relative;
}

.product_img {
  margin: auto 0;
  width: 82px;
  height: 82px;
  display: block;
}
.product_item_rt {
  display: flex;
  flex-direction: column;
  margin-left: 8px;
  width: calc(100% - 90px);
}
.name {
  font-size: 13px;
  color: #222222;
  line-height: 18px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  margin-top: 0;
  margin-bottom: auto;
  display: flex;
  flex-direction: row;
}
.name_tag {
  display: inline-block;
  border-radius: 8px;
  border: 1px solid rgba(183, 130, 65, 1);
  font-size: 12px;
  font-weight: 400;
  color: rgba(183, 130, 65, 1);
  line-height: 16px;
  padding: 0 8px;
  margin-right: 5px;
}
.name_tags {
  padding: 8px 0;
}

.tags_num {
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: LEFT;
  color: rgba(0, 0, 0, 0.5);
}

.expiration {
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: LEFT;
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 10px;
}

.price {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.p_price {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: LEFT;
  color: #000000;
}
.p_price_point {
  font-size: 12px;
}
.p_sub {
  font-size: 14px;
  font-weight: 400;
  color: #000000;
}

.detail_prices {
  margin-top: 10px;
  background: #fff;
  border-radius: 10px;
  color: #222222;
  font-size: 14px;
}

.first {
  display: inline-block;
}

.first_right {
  font-size: 14px;
  font-weight: 500;
  color: #000;
}

.com {
  margin-top: 8px;
}

.cuntdown {
  padding: 12px;
  font-size: 12px;
  background: rgba(253, 241, 225, 1);
  text-align: center;
  line-height: 20px;
}

.cundown_time {
  width: 100px;
  margin: auto 0;
  text-align: right;
  display: inline-block;
}

.item {
  display: inline-block;
}

.detail_top_total {
  padding: 12px;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  text-align: left;
  display: flex;
}

.avatar {
  margin: auto 0;
}

.avatar_img {
  width: 58px;
  height: 58px;
  border-radius: 29px;
  display: block;
}

.total_info {
  margin: auto 12px;
  width: calc(100% - 182px);
  font-size: 16px;
  color: #000;
}

.skuNum {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: LEFT;
  color: rgba(0, 0, 0, 0.5);
}

.totalPrice {
  margin-top: 6px;
  font-size: 14px;
  font-weight: 400;
}

.totalPrice_value {
  color: #fd2824;
  font-weight: 500;
}

.send_card {
  line-height: 40px;
  text-align: center;
  border-top: 1px solid #ebebeb;
  font-size: 15px;
  font-weight: 400;
  color: #222;
  cursor: pointer;
}
.wx_img {
  margin-top: 6px;
  width: 28px;
}

.detail_info {
  margin-top: 10px;
  background: #fff;
  border-radius: 10px;
  font-size: 14px;
}

::v-deep .van-cell__title {
  font-size: 14px;
  color: #000;
}

.cell_value {
  color: #000;
  font-weight: 400;
  font-size: 14px;
}

.error {
  padding: 4px 16px;
  color: red;
}

.badge {
  position: absolute;
  left: 12px;
  top: 12px;
  width: 32px;
}

.address {
  margin-top: 10px;
  background: #fff;
  border-radius: 10px;
  padding: 12px;

  .address_info {
    font-size: 13px;
  }

  .address_detail {
    font-size: 13px;
    color: #999;
  }
}
</style>
